import React, { useEffect, useMemo, useState } from "react";
import Table from "../../components/table/Table";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getInterfaceEthernets } from "../../features/apiCalls";
import { badge } from "../../components/common/Utils";
import { BarChartLineFill } from "react-bootstrap-icons";
import EthernetLiveBandwidth from "./EthernetLiveBandwidth";
import useISPowner from "../../hooks/useISPOwner";
import { connectSocket } from "../../socket";

const Ethernet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //---> Get user & current user data form useISPOwner hooks
  const { currentUser } = useISPowner();

  const ethernets = useSelector((state) => state?.mikrotik?.ethernet);

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);
  const [ethernetData, setEthernetData] = useState({});
  const [show, setShow] = useState(false);
  const [modalStatus, setModalStatus] = useState("");

  useEffect(() => {
    connectSocket(currentUser?.user.id);

    getInterfaceEthernets(dispatch, setIsLoading);
  }, []);

  const columns = useMemo(
    () => [
      {
        width: "5%",
        Header: "#",
        id: "row",
        accessor: (row) => Number(row.id + 1),
        Cell: ({ row }) => <strong>{Number(row.id) + 1}</strong>,
      },
      {
        width: "15%",
        Header: t("name"),
        accessor: "name",
      },
      {
        width: "5%",
        Header: t("status"),
        accessor: "running",
        Cell: ({ cell: { value } }) => badge(value ? "up" : "down"),
      },
      {
        width: "10%",
        Header: t("mikrotik"),
        accessor: "mikrotikName",
      },
      {
        Header: () => <div className="text-center">{t("action")}</div>,
        width: "6%",
        id: "option",
        Cell: ({ row: { original } }) => {
          return (
            <div className="d-flex justify-content-center align-items-center">
              <button
                onClick={() => {
                  setModalStatus("ethernetBandwidth");
                  setShow(true);
                  setEthernetData(original);
                }}
                className="btn btn-sm btn-outline-primary"
              >
                <BarChartLineFill />
              </button>
            </div>
          );
        },
      },
    ],
    [t],
  );

  return (
    <>
      <Table isLoading={isLoading} columns={columns} data={ethernets} />

      {modalStatus === "ethernetBandwidth" && (
        <EthernetLiveBandwidth
          show={show}
          setShow={setShow}
          ethernet={ethernetData}
        />
      )}
    </>
  );
};

export default Ethernet;
